import React from "react";
import { getObjectUseCase, upsertUseCase } from "../../../usecases/object";
import withRouter from "../../../withRouter";
import BaseFormPage from "../../../base/BaseFormPage";
import NavBar from "../../../components/navbar";
import InquiriesViewPresenter from "./InquiriesViewPresenter";
import calculateQuotation from "../../../calculateQuotation";

class InquiriesViewPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, client: null, advanced: false };
    this.presenter = new InquiriesViewPresenter(
      this,
      getObjectUseCase({ include: ["client"] }),
      upsertUseCase(),
    );
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  getStatus(object) {
    return object?.status;
  }

  render() {
    const object = this.state.object;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const {
      parseNum,
      formatNum,
      grossFloorArea,
      netOfUnitTypeDiscount,
      launchDiscountValue,
      equityValue,
      monthlyAmortization,
      retentionValue,
      closingFeeValue,
    } = calculateQuotation(object);
    return (
      <>
        <NavBar
          action={() => (
            <div className="dropdown dropstart d-inline-block">
              <i
                role="button"
                data-bs-toggle="dropdown"
                className="bi bi-three-dots-vertical"
              ></i>
              <div className="dropdown-menu fs-xs">
                <button
                  onClick={this.onClickAdvance.bind(this)}
                  className="dropdown-item py-3"
                >
                  <i className="bi bi-gear pe-2" />
                  Toggle Advance
                </button>
              </div>
            </div>
          )}
        />
        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="d-flex align-items-center">
                  <i
                    className="bi bi-chevron-left"
                    style={{ fontSize: "1.5rem", cursor: "pointer" }}
                    onClick={this.onClickBack.bind(this)}
                  ></i>
                  <h1 className="fw-bold text-capitalize m-0">
                    {schema.label || this.getCollectionName()}
                  </h1>
                </div>
                <span
                  className={`badge rounded-pill fw-light fs-sm ${
                    this.getStatus(object) === "Draft"
                      ? "bg-dark"
                      : this.getStatus(object) === "Closed Deal"
                        ? "bg-primary text-black"
                        : this.getStatus(object) === "Pending (Warm Lead)"
                          ? "bg-warning text-black"
                          : this.getStatus(object) === "Pending (Cold Lead)"
                            ? "bg-success"
                            : this.getStatus(object) === "Cancelled"
                              ? "bg-danger"
                              : "bg-secondary"
                  }`}
                >
                  {this.getStatus(object)}
                </span>
              </div>
              <div className="mt-3 bg-white border border-gray rounded p-3 px-lg-5 py-lg-4">
                <h6 className="text-muted fw-bolder">Basic Information</h6>
                <hr className="border border-gray border-1 opacity-100" />
                <div>
                  <strong>First Name: </strong> {this.state.client?.first_name}
                </div>
                <div>
                  <strong>Last Name: </strong> {this.state.client?.last_name}
                </div>
                <div>
                  <strong>Phone Number: </strong>{" "}
                  {this.state.client?.contact_number}
                </div>
                <div>
                  <strong>Email Address: </strong>{" "}
                  {this.state.client?.email_address}
                </div>
                <div>
                  <strong>Reason for Cancellation: </strong>{" "}
                  {this.state.object?.reason}
                </div>
              </div>
              <div className="mt-3 bg-white border border-gray rounded p-3 px-lg-5 py-lg-4">
                <div className="d-flex justify-content-between">
                  <div className="d-flex">
                    {object.second_logo && (
                      <div>
                        <img
                          src={object.second_logo}
                          alt="Second logo"
                          style={{ maxWidth: "50px", maxHeight: "50px" }}
                        />
                      </div>
                    )}
                  </div>
                  <div className="d-flex">
                    {object.logo && (
                      <div>
                        <img
                          src={object.logo}
                          alt="First logo"
                          style={{ maxWidth: "50px", maxHeight: "50px" }}
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div className="d-flex justify-content-center mt-3 overflow-x-auto">
                  <table className="min-w-full table-fixed text-center border border-gray-900 text-black">
                    <tbody>
                      {[
                        { label: "Payment Term", value: object.payment_term },
                        { label: "Unit Type", value: object.unit_type },
                        { label: "Unit", value: object.unit },
                        { label: "Unit View", value: object.unit_view },
                        {
                          label: "Floor Area (SQM)",
                          value: formatNum(object.floor_area),
                        },
                        {
                          label: "Balcony (SQM)",
                          value: formatNum(object.balcony),
                        },
                        {
                          label: "Gross Floor Area",
                          value: formatNum(grossFloorArea),
                        },
                        {
                          label: "Gross Unit Price",
                          value: formatNum(object.gross_unit_price),
                        },
                        {
                          label: "Unit Type Discount",
                          value: formatNum(object.unit_type_discount),
                        },
                        {
                          label: "Net of Unit Type Discount",
                          value: formatNum(netOfUnitTypeDiscount),
                        },
                        {
                          label: "Launch Discount",
                          value: formatNum(launchDiscountValue),
                        },
                        { label: "Equity", value: formatNum(equityValue) },
                        {
                          label: "Reservation Fee",
                          value: parseNum(object.reservation_fee),
                        },
                        {
                          label: "Monthly Amortization",
                          value: formatNum(monthlyAmortization),
                        },
                        {
                          label: "Retention",
                          value: formatNum(retentionValue),
                        },
                        {
                          label: "Closing Fee",
                          value: formatNum(closingFeeValue),
                        },
                      ].map((item, index) => (
                        <tr key={index}>
                          <td
                            className={`${item.label === "Payment Term" ? "" : "bg-primary border border-gray-900"} px-4 fs-sm fw-bold`}
                          >
                            {item.label}
                          </td>
                          <td
                            className={`${item.label === "Payment Term" ? "p-2 fs-sm" : "p-2 fs-sm border border-gray-900"}`}
                          >
                            {item.value || "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {!["Closed Deal", "Cancelled"].includes(
                  this.getStatus(object),
                ) && (
                  <div className="mt-4 d-flex justify-content-center">
                    <button
                      type="button"
                      className="btn btn-primary fs-sm w-100 fw-bolder text-black"
                      onClick={() =>
                        this.navigateTo(
                          `/inquiries/quotation/form/${object?.id}`,
                        )
                      }
                    >
                      Edit
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(InquiriesViewPage);
